










































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Input from '@/components/inputs/Input.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Select from '@/components/Select.vue'
import Address from './Address.vue'
import {
  EPaymentReceiptType,
  IResidentContact
} from '@zunta/configurations'
import Modal from '@/components/Modal.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { EMAIL_REGEX } from '@/constants'

@Component({
  props: {
    receiptTo: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Checkbox,
    Modal,
    Address,
    Icon,
    Input,
    Select,
    ErrorMessages
  }
})
export default class Recipients extends Vue {
  EPaymentReceiptType: any = EPaymentReceiptType
  emailForm: any = {}
  addEmailErrors: string[] = []
  showAddEmailModal: boolean = false
  receiptToLocal: any[] = []

  mounted () {
    this.$watch('receiptTo', value => {
      this.receiptToLocal = value
    }, { immediate: true })
  }

  checked (email: string) {
    return !!this.receiptToLocal.find((contact: any) => contact.email === email)
  }

  setShowAddEmailModal (value: boolean) {
    this.showAddEmailModal = value
  }

  toggleContact (value: boolean, contact: Partial<IResidentContact>) {
    const contactIndex = this.receiptToLocal.findIndex((item: Partial<IResidentContact>) => item.email === contact.email)
    contactIndex !== -1
        ? this.receiptToLocal[contactIndex].checked = value
        : this.receiptToLocal.push({ ...contact, checked: true })
    this.$emit('select', this.receiptToLocal.filter((item: any) => item.checked).map((item: any) => {
      return {
        name: item.name ? item.name : ((item.firstName ? item.firstName : '') /* + ' ' + (item.lastName ? item.lastName : '') */),
        email: item.email
      }
    }))
  }

  validateAddEmail () {
    const requiredFieldsErrorsMap: any = {
      email: 'Email is Required',
      firstName: 'First Name is Required'
      // lastName: 'Last Name is Required'
    }
    this.addEmailErrors = []

    Object.keys(requiredFieldsErrorsMap).forEach((fieldName: string) => {
      if (!this.emailForm[fieldName]) {
        this.addEmailErrors.push(requiredFieldsErrorsMap[fieldName])
      }
      const regex = EMAIL_REGEX
      if (fieldName === 'email' && !regex.test(this.emailForm.email)) {
        this.addEmailErrors.push('This is not a valid email address.')
      }
    })
    return this.addEmailErrors.length === 0
  }

  saveEmail () {
    if (!this.validateAddEmail()) {
      return
    }
    this.addTempContacts({
      ...this.emailForm
    })
    this.emailForm = {}
    this.setShowAddEmailModal(false)
  }

  addTempContacts (contactData: Partial<IResidentContact>) {
    this.toggleContact(true, contactData)
  }
}
